module.exports = __webpack_public_path__ + "img/icon-rts.0b4b6497.svg";